import 'slick-carousel/slick/slick';

jQuery(document).ready(function(){

    jQuery(".hero-background-slider").on("init", function (event, slick, currentSlide) {
        var currentVideo = jQuery(slick.$slides.get(currentSlide)).find("video");

        if(currentVideo.length != 0){
            jQuery(currentVideo).get(0).pause();
            jQuery(currentVideo).get(0).currentTime = 0;
            jQuery(currentVideo).get(0).play();
        }  

        // var bgColor = jQuery(slick.$slides.get(currentSlide)).find(".hero-background-slider__slide").attr("data-background-color");

        // if (typeof bgColor !== "undefined") {
        //     jQuery(".hero-background-slider").css("background-color", bgColor);
        // } else {
        //     jQuery(".hero-background-slider").css("background-color", "transparent");
        // }
    });

    jQuery(".hero-background-slider").slick({
        prevArrow: jQuery(".hero .hero__prev"),
        nextArrow: jQuery(".hero .hero__next"),
        fade: true,
        asNavFor: jQuery(".hero-packshot-slider"),
        adaptiveHeight: true
    });

    jQuery(".hero-background-slider").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
            var nextVideo = jQuery(slick.$slides.get(nextSlide)).find("video");
            // var bgColor = jQuery(slick.$slides.get(nextSlide)).find(".hero-background-slider__slide").attr("data-background-color");

            // if (typeof bgColor !== "undefined") {
            //     jQuery(".hero-background-slider").css("background-color", bgColor);
            // } else {
            //     jQuery(".hero-background-slider").css("background-color", "transparent");
            // }

            if(nextVideo.length != 0){
                jQuery(nextVideo).get(0).pause();
                jQuery(nextVideo).get(0).currentTime = 0;
                jQuery(nextVideo).get(0).play();
            }   
        }
    );
});
